import {
  chronicleDeviceRecordingInfoAtom,
  chronicleIsPausedAtom,
  chronicleSessionIdAtom,
} from '@/atoms/chronicle';
import { useAtomValue } from 'jotai';

import { useIsLiveOfflineRemoteSession } from '@/hooks/desktop/useIsLiveOfflineRemoteSession';
import { useIsRemoteReconnectedSession } from '@/hooks/desktop/useIsRemoteReconnectedSession';

/**
 * True when `sessionId` is the live, unpaused Remote recording with active
 * `recordingInfo`. Dual-id match; yields to live-offline / reconnected.
 */
export function useIsLiveRunningRemoteSession(
  sessionId: string | null | undefined
): boolean {
  const activeChronicleSessionId = useAtomValue(chronicleSessionIdAtom);
  const recordingInfo = useAtomValue(chronicleDeviceRecordingInfoAtom);
  const isPaused = useAtomValue(chronicleIsPausedAtom);
  const isLiveOffline = useIsLiveOfflineRemoteSession(sessionId);
  const isReconnectedPendingEnd = useIsRemoteReconnectedSession(sessionId);

  if (!sessionId || !activeChronicleSessionId) return false;
  if (isPaused) return false;
  if (isLiveOffline || isReconnectedPendingEnd) return false;
  if (!recordingInfo) return false;

  return sessionId === activeChronicleSessionId || sessionId === recordingInfo.sessionId;
}
